import PricingIcon from "@/assets/icons/PricingPlan.svg";
import { setShowMobileSideBar } from "@/redux/feature/global/globalSlice";
import { useGetMeQuery } from "@/redux/feature/user/userApi";
import { useAppDispatch, useAppSelector } from "@/redux/hooks/hooks";
import MessageIcon from "@/assets/icons/Messages.svg";
import NotificationIcon from "@/assets/icons/Notification.svg";
import HamBurgerIcon from "@/assets/icons/HamBurgerIcon.svg";
import CreditCoin from "@/assets/images/credit/creditIcon.png";
import { CustomButton } from "@/components/ui/Buttons";
import { Link } from "react-router-dom";
import logo from "@/assets/logo/logo-with-text.png";

const MobileHeader = () => {
  const { user } = useAppSelector((state) => state.auth);
  const { data } = useGetMeQuery(user?.email);
  const credits = data?.data?.credits;
  const dispatch = useAppDispatch();
  return (
    <div className="w-full flex items-center justify-between gap-x-4 md:hidden">
      <div className="flex gap-3 items-center">
        <button onClick={() => dispatch(setShowMobileSideBar(true))}>
          <HamBurgerIcon />
        </button>
        <div className="w-[110px]">
          <img src={logo} alt="passionbits-logo" />
        </div>
      </div>
      <div>
        {credits === 0 ? (
          <div className="flex gap-5 items-center">
            <SubscribeButton />
            <NotificationIcon />
          </div>
        ) : (
          <div className="flex gap-5 items-center">
            <div className="flex items-center gap-1 bg-[#FECB1E26] border-[1.5px] border-[#FEC006] text- py-1 px-2.5 rounded-lg text-[#FEC614] text-sm leading-5 tracking-[-1%] font-semibold">
              <span className="text-red-500!">
             <img src={CreditCoin} alt=""/>
              </span>
             
              {credits}
            </div>
        <Link to={'/notifications'}>
        <NotificationIcon /></Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default MobileHeader;

const SubscribeButton = () => (
  <Link to="/pricing">
    <CustomButton
      padding="4px 10px"
      backgroundColor="#FFF"
      borderRadius="8px"
      border="1px solid #FEC614"
      fontSize="14px"
      fontWeight="600"
      color="#D59F01"
    >
      <div className="flex items-center gap-x-2">
        <PricingIcon />
        Subscribe
      </div>
    </CustomButton>
  </Link>
);
